module.exports = __webpack_public_path__ + "static/media/areas_arrow.d938ef99.svg";